import { Component, inject } from '@angular/core';
import { SubstituteDocumentTypeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SubstituteDocumentTypeCreateDto,
  SubstituteDocumentTypeDto,
  SubstituteDocumentTypeExcelDownloadDto,
  SubstituteDocumentTypeUpdateDto,
} from '../proxy/controlling/dtos/substitute-document-type';
import { SUBSTITUTEDOCUMENTTYPE_CONFIG, SUBSTITUTEDOCUMENTTYPE_FIELDS } from './substitute-document-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-substitute-document-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SubstituteDocumentTypeService, ConfirmationService],
  templateUrl: './substitute-document-type.html',
  styleUrl: './substitute-document-type.scss',
})
export class SubstituteDocumentType extends BaseCrudComponent<
  SubstituteDocumentTypeDto,
  SubstituteDocumentTypeCreateDto,
  SubstituteDocumentTypeUpdateDto,
  SubstituteDocumentTypeExcelDownloadDto
> {
  service = inject(SubstituteDocumentTypeService);
  config = SUBSTITUTEDOCUMENTTYPE_CONFIG;
  fields = SUBSTITUTEDOCUMENTTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: SubstituteDocumentTypeDto): SubstituteDocumentTypeUpdateDto {
    return {
      parentId: data.parentId,
      substituteId: data.substituteId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SubstituteDocumentType';
  }
}
